import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { JoinPage } from '@/components/route/referral/JoinPage';
import HeadMeta from '@/components/static-pages/HeadMeta';
import Loading from '@/components/switchback/Loading/Loading';
import { useRouter } from '@/hooks/useRouter';
import {
  selectAuthenticated,
  selectAuthenticating,
  selectHasTriedFetch,
} from '@/redux/modules/auth/selectors';
import { TRootState } from '@/redux/rootReducer';

const Join: NextPage = () => {
  const intl = useIntl();
  const router = useRouter();

  const isAuthenticated = useSelector<TRootState>(selectAuthenticated);
  const isAuthenticating = useSelector<TRootState>(selectAuthenticating);
  const hasTriedFetch = useSelector(selectHasTriedFetch);

  useEffect(() => {
    if (!hasTriedFetch) return;
    // We do not care if they are authenticating, since that may fail.
    // Once they are finally authenticated, we switch to the redirect path.
    if (isAuthenticated) router.replace('/referral/renter');
  }, [isAuthenticated, hasTriedFetch, router]);

  const showLoading = Boolean(isAuthenticated || isAuthenticating || !hasTriedFetch);

  return (
    <div className="relative">
      <HeadMeta
        title={intl.formatMessage({
          defaultMessage: 'Refer friends for an RV adventure',
          id: 'U3BCCJ',
        })}
        description={intl.formatMessage({
          defaultMessage:
            'Refer a friend to take a trip on Outdoorsy, the #1 most trusted RV rental marketplace in the world. They’ll get $50 off their trip, and you’ll get $75',
          id: '5e+/N7',
        })}
      />
      <JoinPage />
      {showLoading && (
        <div className="absolute inset-0 z-50 flex justify-center bg-white">
          <Loading className="mt-[40vh]" />
        </div>
      )}
    </div>
  );
};

export default Join;
